import { createApi } from '@reduxjs/toolkit/query/react';
import {
  GetUsersAndRolesParams,
  GetUsersAndRolesResponse,
  PostUser,
  PostUsersAndRolesResponse,
} from 'lib.store/src/main/users-roles/models';
import { baseQueryWithReauth } from '../baseQueryWithReauth';
const users_roles = `users_roles`;

export const usersRolesApi = createApi({
  reducerPath: users_roles,
  baseQuery: baseQueryWithReauth,
  tagTypes: [users_roles],
  endpoints: (build) => ({
    getUsers: build.query<
      GetUsersAndRolesResponse,
      GetUsersAndRolesParams & { isOrganizer?: boolean }
    >({
      query: ({ isOrganizer, page, sortField, sortDirection }) => {
        const params = new URLSearchParams();

        if (page) {
          params.append('page', page.toString());
        }

        if (sortField && sortDirection) {
          params.append('sort[0][field]', sortField);
          params.append('sort[0][direction]', sortDirection);
        }

        const queryString = params.toString();
        return {
          url: `/${isOrganizer ? 'organizer' : 'partner'}/users${queryString ? '?' + queryString : ''}`,
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
      providesTags: [users_roles],
    }),
    postUser: build.mutation<PostUsersAndRolesResponse, PostUser & { isOrganizer?: boolean }>({
      query: (body) => {
        const { isOrganizer, ...rest } = body;
        return {
          body: rest,
          method: 'POST',
          url: `/${isOrganizer ? 'organizer' : 'partner'}/users`,
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
      invalidatesTags: [users_roles],
    }),
    patchUser: build.mutation<PostUsersAndRolesResponse, PostUser & { isOrganizer?: boolean }>({
      query: (body) => {
        const { id, isOrganizer, ...rest } = body;
        return {
          url: `/${isOrganizer ? 'organizer' : 'partner'}/users/${id ? id.toString() : ''}`,
          method: 'PATCH',
          body: rest,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        };
      },
      invalidatesTags: [users_roles],
    }),
    deleteUserById: build.mutation<void, { id: number } & { isOrganizer?: boolean }>({
      query: ({ id, isOrganizer }) => ({
        method: 'DELETE',
        url: `/${isOrganizer ? 'organizer' : 'partner'}/users/${id}`,
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
      }),
      invalidatesTags: [users_roles],
    }),
  }),
});

export const {
  useGetUsersQuery,
  usePostUserMutation,
  usePatchUserMutation,
  useDeleteUserByIdMutation,
} = usersRolesApi;
